/**
 * Utility functions for franchise fee payout operations
 */

export interface StatusChipProps {
  color: 'secondary' | 'warning' | 'success' | 'error';
  label: string;
}

/**
 * Get status chip properties for a payout status
 * @param status - The payout status
 * @returns Object with color and label properties for the status chip
 */
export const getPayoutStatusChipProps = (status: string): StatusChipProps => {
  switch (status) {
    case 'not_started':
      return { color: 'secondary', label: 'Not Started' };
    case 'in_progress':
      return { color: 'warning', label: 'In Progress' };
    case 'completed':
      return { color: 'success', label: 'Completed' };
    case 'failed':
      return { color: 'error', label: 'Failed' };
    default:
      return { color: 'secondary', label: status };
  }
};

/**
 * Check if a payout can be modified (adjustments can be added/edited/deleted)
 * @param status - The payout status
 * @returns True if the payout can be modified
 */
export const canModifyPayout = (status: string): boolean => {
  return status === 'not_started';
};
